import script from "./GuildNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuildNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./GuildNavigation.vue?vue&type=style&index=0&id=45c1173f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45c1173f"]])

export default __exports__